/*@Id :tab id and each customer account have unique id
@title :show tab title
@active : froze and unfroze will decide 
@additionalAccount:tab is reated additonal accountor not 
@customerSessionId :Unqiue session id for each tab
@closeIcon:Which tabs not required close icon
@activeCall:Live call realted tab will true other tabs false
@activeChat :live chat related tab will be true other tabs false 
@iconClass:which icon and class required for this tab
@idle:To maintain idle timer
@isWrapupDone:To maintain wrap-up in call/chat
@conversationId:To maintain the Intraction histoory in Database 
@startTime:To maintain history when account is open 
@endTime:to maintain the history when account is close
@channel :which base account is open reseach ,call,chat
@reasonForAdditional: which reason base additional account will open in CALL/CHAT CCR1-1180 */

import { GEN_attributes } from "./customer.model";
import { WrapUpData } from "./WrapUpData";
import * as Constants from './Constants';

export interface eGainData {
  name: string, content: string
}

export interface eGainHtml {
  overViewHtml: eGainData,
  authenticationHtml: eGainData,
  authenticationConfig: any,
  authenticationType: string, overViewError: string, authEgainError: string
};

export class platformTypeTableData {
  public displayPlatformInternalIdTable: boolean = false;
  public platformTypeData: any[] = [];
}

export class aiSummaryStatus {
  isCallSummaryTooShort: boolean = false;
  isCallSummaryFetching: boolean = false;
  isCallSummaryApiForbidden: boolean = false;
  isCallSummaryApiError: boolean = false;
  isCallSummaryApiNoPermission: boolean = false;
  isCallSummaryAvailable: boolean = false;
}

/**CCR1-10309 */
export class viewJsonData {
  viewUDPJSONDataMap: Map<string, any[]> = new Map<string, any[]>();
  selectedAPIName: string = '';
  apiFailed: boolean = false;
  apiNameList: any[] = []

}
export class clearIdentityData {
  isClearIdentityEnabled: boolean = false;
  identityVerificationType: string = ''; // no AIDV option pre-selected until the agent picks one
  identityVerificationConfig: any;
  identityVerificationContent: any;
  step1Active: boolean = false;
  step1Part2: boolean = false;
  step1Part3: boolean = false;
  step1Complete: boolean = false
  step2Active: boolean = false;
  step2Part2: boolean = false;
  step2ErrorMsg:string='';
  step2Failed: boolean = false;
  mobileNumber: string = '';
  email: string = '';
  countryCode: string = 'US';
  countryCallingCode: string = '';
  step2Complete: boolean = false;
  step3Active: boolean = false;
  step3Complete: boolean = false;
  step3Failed: boolean = false;
  step3ErrorMsg: any = '';
  startADIV: boolean = false;
  step1RadioSelection: string = "Yes";
  step1Part3ToggleSelection: boolean = false;
  step2RadioSelection: string = "";
  step3RadioSelection: string = "";
  step1CheckList: any = [];
  verificationId: string = '';
  retryAttempts: number = Constants.RETRY_ATTEMPTS;
  step3InfoMsg: string = '';
  completedAllSteps: boolean = false;
  timer: number = 0;
  exceededTimeLimit: boolean = false;
}

export class clearFraudIdentityData {  
  identityVerificationType: string = Constants.CLEAR_OPTIONS_CODES.ACCOUNT_ACCESS; 
  step1Active: boolean = false;  
  step1Complete: boolean = false
  step2Active: boolean = false;
  step2Complete: boolean = false;
  step2Failed: boolean = false;
  step2ErrorMsg: string = '';
  step3Active: boolean = false;
  step3Complete: boolean = false;
  StartADIV: boolean = false;
  step1RadioSelection: string = "Yes";
  step2RadioSelection: any;
  step2ToggleSelection: boolean = true;  
  isWebFreezeChecked: boolean = false;
  fraudProtectionMsg: boolean = false;
  mobileNumbers: any = [];
  mobileNumber: any = '';
  emails: any = [];
  email: string = '';
  customEmail: string = '';
  customMobileNumber: string = '';
  isMobileSelected: boolean = false;
  isEmailSelected: boolean = false;
  isCustomMobileSelected: boolean = false;
  isCustomEmailSelected: boolean = false;
  countryCode: string = 'US';
  countryCallingCode: string = '';
  defaultSelectedValue: any = '';
  verificationId: string = '';
  step3Failed: boolean = false;
  step3ErrorMsg: any = '';
  retryAttempts: number = Constants.RETRY_ATTEMPTS;
  step3InfoMsg: string = '';
  completedAllSteps: boolean = false;
  timer:number=0;
  exceededTimeLimit:boolean=false;
  
}

export interface biometricData {
  checkBiometricAccessApi: boolean;
  enableBiometric:boolean;
  step1Active: boolean;
  step1Complete: boolean;
  step1Failed: boolean;
  step2Active: boolean;
  step2Complete: boolean;
  step2Failed: boolean;
  step2ErrorMsg:string;
  biometricCompleted:boolean;
  expiredAttempts: number;
}

export class PrivacyPolicyData {
  mobileNumbers: any[] = [];
  emails: any[] = [];
  isLoadingDeliveryOptions: boolean = false;
  isSending: boolean = false;
  sendSuccess: boolean = false;
  sendFailure: boolean = false;
  // Delivery selection state — mirrors clearFraudIdentityData pattern
  defaultSelectedValue: any = null;
  isMobileSelected: boolean = false;
  isEmailSelected: boolean = false;
  isCustomMobileSelected: boolean = false;
  isCustomEmailSelected: boolean = false;
  mobileNumber: string = '';
  email: string = '';
  customEmail: string = '';
  customMobileNumber: string = '';
  countryCode: string = 'US';
}

export class Tab {
  public id: any;
  public title: string;
  public tabData: any;
  public active: boolean;
  additionalAccount: boolean;
  customerSessionId: string;
  closeIcon: boolean;
  public activeCall: boolean;
  public activeChat: boolean;
  public iconClass: string;
  idle: any;
  public outboundCallInitiate: boolean;
  public isWrapupDone: boolean;
  public authenticateStatus: string;
  public CS_SECURITY_LEVEL: string;
  public isAdditionalAccOpen: string;
  public parentId: string;
  public additionalAccountId: string;
  public domainIndex: any;
  public selectedLeftNavMenu: any;
  public subDomainIndex: any;
  public domainsTopics: any;
  public clientId: string;
  public selectedAlisLang: string;
  public customerType: string;
  public channel: string;
  public conversationId: string; public startTime: Date; endTime: Date;
  public reasonForAdditional: any;
  public isChatTransferred: boolean;
  public lastInteractionStatus: string;
  public customerParticipantId: any;
  public isCustAccCaseManagementErrorEnabled: boolean;
  public roleType: string;
  public showContent: boolean;
  public defaultRole: string;
  public startSL: string;
  public endSL: string;
  public showRepeatAlert: boolean = false;
  public repeatAlertMsg: string;
  public repeatCallerCode:string;
  public approvedExceptionsTypes: any;
  showRepeatAlertListView: boolean;
  showRepeatAlertBriefView: boolean;
  public callConnectedTime: string;
  public lastStartTime: any;
  public wrapUpData: WrapUpData;
  public approvedExceptionCredentialData: any;
  public authenticationEgainContent: eGainHtml;
  public approvedExceptionEgainContentData: any;
  public approvedExceptionResouceLinksData: any;
  public approvedExceptionToggleValue: any;
  public approvedExceptionSuccessMsg: any;
  public isApprovedExceptionContinueDisabled: boolean;
  public isApprovedExceptionContinueClicked: boolean;
  public approvedExceptionIH: any;
  //public CP_APPROVED_EXCPTION_SECURED: boolean;
  //public CP_INDICATIVE_DATA_SECURED: boolean;
  public restoreTab: boolean;
  public cimData: string;
  public interactionDisconnected: boolean;
  public wrappedupCroosIcon: boolean;
  public authenticationIndicativeData: any;
  public authenticationPinEntryData: any;
  public authenticationContents: any;
  lastTimerValue: string;
  public genesysAttributes: GEN_attributes;
  public outboundCallDialing: any;
  public IHSelectedRow: any;
  public externalLeaveId: any;
  public personId: string;
  public clientType: string;
  public employeeId: string;
  public unknownCallerLeftNav: any;
  public pinRestTbaGuipostDetails: any[] = [];
  public conversationConnectedTime: string;
  public conversationDisconnectedTime: string;
  public agenInteractionData: any;
  public clientInfoCardData: any[] = [];
  public employmentStatusCode: string;
  public primaryLanguage: string;
  public last4DigitsOfSSN: string;
  public isVIP: boolean;
  // CCR1-14992 Persistent Info changes
  public persistentInfo: any[] = [];
  public clientSpecificDynamicFields: any[] = [];
  public preferredLocale: string;
  public interactionFilterFail: boolean;
  public pinEntryApp: any;
  public pinReset: any;
  public pinChangeApp: any;
  public onDemandEmailData: any;
  public deliveryMethod: any;
  public otcData: any;
  public showEditCommentsModal: boolean;
  public saveWrapUpCommentApiFailure: boolean;
  public webMessage: boolean;
  public selectedVALLang: string;
  public VALData: any;
  public Config_DesktopIndicator: string;
  public personStatus: string;
  loadDisplayAlertComp: boolean = true;
  public viewExpiredAlert: boolean;
  public viewExpiredAlertData: any;
  public deleteExpireAlertApiFailure: boolean;
  public IS_AAAS_ENABLED: boolean = false;
  public approvedExceptionHealthCardData: any = {};
  public IHBriefViewData: any = {};
  public telephonyId: string;
  public pronouns: string = '';
  public authChannel: string = ''; //CCR3-10820
  public isNoPINClient: boolean = false;
  public roleObj: any = {};
  public platformTypeTableData: any;
  public aiSummaryStatus: any;
  public viewJsonData: any;  //CCR1-10309
  public preferredName: any;
  //public sectorName: any;
  public otcInsideFTU: any; //CCR3-13444
  public privacyPolicyStatus: any; //CCR3-12927
  public errorDomains: any; //CCR1-10523
  public displayErrorDomainMsg: boolean; //CCR1-10523
  public isMultipleAccountTabOpened: boolean; //CCR3-13122
  public multiAccountRecord: any[]; //CCR3-13170 multiple account record for each tab to maintain the history of multiple accounts associated with the conversation.
  public documentViewApiFailed: boolean = false; //CCR1-12776 to maintain the state of document view api failure for each tab
  public clearIdentityData: clearIdentityData; //CCR3-13548 to maintain the clear identity data for each tab
  public clearFraudIdentityData: clearFraudIdentityData; //CCR3-13548 to maintain the clear identity data for each tab
  public isGenesysUnsecureSecurityLevelUpdateProcessing: boolean = false;
  public isGenesysUnsecureSecurityLevelUpdatedForIndicativeData: boolean = false;
  public approvedExceptionRefreshSuccessMsg: boolean = false; //CCR1-13888 to maintain the state of approved exception refresh success message for each tab
  public successAErefreshMsgTimeout: any;
  public biometricData: biometricData; //CCR3-15483 to maintain the biometric data for each tab
  public privacyPolicyData: PrivacyPolicyData;
  public makeAnotherCallCheckboxTicked: boolean = false; //CCCR1-15200
  public isEIVSelected:boolean=false;
  constructor() {
    //component: Type<any>, title: string, tabData: any
    this.id = 0;
    this.active = false;
    this.activeCall = false;
    this.activeChat = false;
    this.additionalAccount = false;
    this.tabData = {};
    this.iconClass = '';
    this.customerSessionId = '';
    // this.component = component;
    this.title = '';
    this.closeIcon = true;
    this.idle = '';
    this.outboundCallInitiate = false;
    this.isWrapupDone = false;
    this.authenticateStatus = '';
    this.CS_SECURITY_LEVEL = '0';
    this.isAdditionalAccOpen = '';
    this.parentId = '';
    this.additionalAccountId = '';
    this.domainIndex = {};
    this.selectedLeftNavMenu = {};
    this.subDomainIndex = {};
    this.domainsTopics = [];
    this.clientId = '';
    this.selectedAlisLang = '';
    this.customerType = 'ACH';
    this.channel = '';
    this.conversationId = ''; this.startTime = new Date(); this.endTime = new Date(0);
    this.reasonForAdditional = { firstReason: "", subReason: "" };
    this.isChatTransferred = false;
    this.lastInteractionStatus = '';
    this.customerParticipantId = '';
    this.isCustAccCaseManagementErrorEnabled = false;
    this.roleType = 'Employee';
    this.agenInteractionData = {};
    this.showContent = true;
    this.defaultRole = 'Employee';
    this.startSL = '';
    this.endSL = '';
    this.showRepeatAlert = false;
    this.showRepeatAlertListView = false;
    this.showRepeatAlertBriefView = false;
    this.callConnectedTime = '';
    this.repeatAlertMsg = '';
    this.repeatCallerCode = '';
    this.approvedExceptionsTypes = [];
    this.lastStartTime = '';
    this.wrapUpData = new WrapUpData;
    this.approvedExceptionCredentialData = [];
    this.authenticationEgainContent = { overViewHtml: { name: '', content: "" }, authenticationHtml: { name: '', content: "" }, authenticationType: "", authenticationConfig: null, overViewError: '', authEgainError: '' };
    this.approvedExceptionEgainContentData = [];
    this.approvedExceptionResouceLinksData = [];

    this.isApprovedExceptionContinueDisabled = true;
    this.approvedExceptionToggleValue = false;
    this.approvedExceptionSuccessMsg = false;
    this.isApprovedExceptionContinueClicked = false;
    this.approvedExceptionIH = new Map();
    //this.CP_APPROVED_EXCPTION_SECURED = false;
    //this.CP_INDICATIVE_DATA_SECURED = false;
    this.restoreTab = false;
    this.cimData = '';
    this.interactionDisconnected = false;
    this.wrappedupCroosIcon = false;
    this.authenticationIndicativeData = {};
    this.authenticationPinEntryData = {};
    this.authenticationContents = [];
    this.lastTimerValue = '';
    this.genesysAttributes = new GEN_attributes();
    this.IHSelectedRow = {};
    this.externalLeaveId = '';
    this.outboundCallDialing = false;
    this.personId = '';
    this.clientType = '';
    this.employeeId = '';
    this.unknownCallerLeftNav = {};
    this.pinRestTbaGuipostDetails = [],
      this.conversationConnectedTime = '';
    this.conversationDisconnectedTime = '';
    this.clientInfoCardData = [];
    this.employmentStatusCode = '';
    this.primaryLanguage = '';
    this.last4DigitsOfSSN = '';
    this.isVIP = false;
    this.preferredLocale = '';
    this.interactionFilterFail = false;
    this.pinEntryApp = { step1Active: true, step1Complete: false, step2Active: false, step2Complete: false, step3Active: false, step3Complete: false, success: null, pinValidMsg: false, indValidMsg: false, pinError: "", securityDowngraded: false };
    // CCR3-11548 Added pinChngError to show dynamic error message
    this.pinChangeApp = { pinChangePrcActive: false, step1Active: true, step1Complete: false, step2Active: false, step2Complete: false, step3Active: false, step3Complete: false, pinChangeSucess: false, retryBtn: false, step3Failed: false, pinChngError: "" };
    this.onDemandEmailData = { emailId: '', emailTemplateList: [], selectedTemplateList: {}, onDemandEmailConfigMiss: false, onDemandEmailApiFailure: false, sentEmailSuccess: false, sentEmailFailed: false }
    this.pinReset = { step1Active: true, step1Complete: false, step2Active: false, step2Complete: false, step2Failed: false, step3Active: false, step3Complete: false, step3Failed: false, success: null };
    this.deliveryMethod = [];
    // this.deliveryMethod=[{value:"Postal address",disabled:"false"},{value:"Email address",disabled:"false"}];
    this.showEditCommentsModal = false;
    this.saveWrapUpCommentApiFailure = false;
    this.otcData = { otcConfigData: {}, step1Active: false, 
                    deliveryMethodSDataMiss:false, step2Active: false, step3Active: false, selectedDeliveryMethod: {},
                     selectedPhoneNumber: '', selectedCountryCode:'', deliveryMethodApiFail: false,
                      deliveryMethodConfigMiss: false, sendOTCSuccess: false, notEligiblePhoneNumber: false, 
                      otcDenied: false, generateOTCApiFailure: false, validateOtcSuccess: false, validateOtcFail: false, 
                      validateOtcApiFailure: false, validateOtcLocked: false, typedOTC: '', otcExpired: false, 
                      selectedEmail: '', validateOTCApiProcessing: false ,generateOTCInProgress : false,
                      status:'NA', unStopPhoneNumberStatusApiSuccess: false, unStopPhoneNumberStatusApiFailure: false, unStopPhoneNumberStatusApiFailureDetails: ''
                    
                    };
    this.webMessage = false;//CCR3-8214
    this.selectedVALLang = ''; //CCR1-8079
    this.VALData = { displayContentBeforeStep1: true, displayStep2Content: false, displayStep1Content: false, enableStepper: false, step1Complete: false, step2Complete: false, selectedVALLang: '', isPopupDisplayed: false, valProcessActive: false, displayStep3ContentAfterResponse: false, displayStep3ContentAfterResponseSuccess: false, step3Complete: false, displayStep3Content: false, successMsg: '', errMsg: '' };//CCR1-8079
    this.Config_DesktopIndicator = '';
    this.personStatus = 'NA';
    this.loadDisplayAlertComp = false;
    this.viewExpiredAlert = false;
    this.viewExpiredAlertData = { startDate: null, endDate: null, viewExpiredAlerts: [], viewExpiredAlertTableData: [], selectedRow: {}, selectedRowDetailData: {}, searchForExpiredAlert: false, viewExpiredAlertApiFailure: false };
    this.deleteExpireAlertApiFailure = false;
    this.IS_AAAS_ENABLED = false;
    this.telephonyId = '';
    this.approvedExceptionHealthCardData = { healthCardData: [], healthCardApiFailure: false, healthCardConfigMiss: false };
    this.IHBriefViewData = { 'apiFailed': false, isDataPresent: false }
    this.pronouns = '';
    this.authChannel = '';//CCR3-10820
    this.isNoPINClient = false;
    this.roleObj = {};
    this.platformTypeTableData = new platformTypeTableData();
    this.aiSummaryStatus = new aiSummaryStatus();
    this.viewJsonData = new viewJsonData();
    this.otcInsideFTU = { hasAccountBalance: false, isOTCValidated: false }; //CCR3-13444
    this.privacyPolicyStatus = '';
    this.displayErrorDomainMsg = false;
    this.errorDomains = '';
    this.isMultipleAccountTabOpened = false; //CCR3-13122
    this.multiAccountRecord = [];
    this.documentViewApiFailed = false; //CCR1-12776 to maintain the state of document view api failure for each tab
    this.clearIdentityData = new clearIdentityData(); //CCR3-13396 to maintain the clear identity data for each tab
   this.clearFraudIdentityData = new clearFraudIdentityData(); //CCR3-13396 to maintain the clear identity data for each tab
   this.isGenesysUnsecureSecurityLevelUpdateProcessing = false;
   this.isGenesysUnsecureSecurityLevelUpdatedForIndicativeData = false;
   this.approvedExceptionRefreshSuccessMsg = false; //CCR1-13478 to maintain the state of approved exception refresh success message for each tab
   this.successAErefreshMsgTimeout = null;
   this.biometricData = { enableBiometric: false, checkBiometricAccessApi: false, step1Active: false, step1Complete: false, step1Failed: false, step2Active: false, step2Complete: false, step2Failed: false, step2ErrorMsg:'', biometricCompleted:false, expiredAttempts:0}; //CCR3-15483 to maintain the biometric data for each tab
   this.privacyPolicyData = new PrivacyPolicyData();
   this.makeAnotherCallCheckboxTicked = false;
   this.isEIVSelected = false;
   // CCR1-14992 Persistent Info changes
   this.persistentInfo = [];
   this.clientSpecificDynamicFields = [];
  }
}
